import moment from 'moment';

export const setEntryLocale = () => {
    moment.locale(pmkinoFrontVars && pmkinoFrontVars.translation && pmkinoFrontVars.translation.locale ? pmkinoFrontVars.translation.locale : 'de-DE');
}